export default [
  {
    path: '/member/list',
    name: 'member-list',
    component: () => import('@/views/members/members-list/MembersList.vue'),
   
  },
  {
    path: '/member/view/:id/:isEdit',
    name: 'member-view',
    component: () => import('@/views/members/members-view/MembersView.vue'),
   
  },
  {
    path: '/member/edit/:id',
    name: 'member-edit',
    component: () => import('@/views/members/members-edit/MembersEdit.vue'),
   
  },
  {
    path: '/member/add',
    name: 'member-add',
    component: () => import('@/views/members/members-edit/MembersEdit.vue'),
  },
]
